import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { StorageBackendValidatorsEnum } from '@zaoblako/shared/modules/storage/enums/storage-backend-validators.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { SecurityDtoKeysEnum } from '@zaoblako/shared/modules/security/enums/security-dto-keys.enum';
import { entityLikeSchemaUuid } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import { nonEmptyStringSchema } from '@zaoblako/shared/modules/serde/schemas/non-empty-string.schema';
import type { FileFindInterface } from '@zaoblako/shared/modules/storage/dtos/file/file-find.dto';
import type { OnlyIdRequiredInterface } from '@zaoblako/shared/common/interfaces/only-id-required.interface';

import * as yup from 'yup';

/** Profile create/update request body */
export interface ProfileFormInterface {
  /** User email address (login) */
  email: string;
  /** User's phone number */
  phone?: string;
  /** User's Google email address (for Google integration) */
  gmail?: string;
  /** User's first (personal) name */
  firstName: string;
  /** User's middle (additional) name or surname */
  middleName?: string;
  /** User's last (family) name */
  lastName?: string;
  /** User's avatar file */
  file?: OnlyIdRequiredInterface<FileFindInterface>;
  /** If `true` then entity cards should be opened in new tab */
  cardOnNewTab?: boolean;
}

/** Profile create/update request body - DTO schema */
export const ProfileFormDto = SerdeDtoClass.create<ProfileFormInterface>(SecurityDtoKeysEnum.PROFILE_FORM_DTO, {
  email: {
    sortable: true,
    label: 'Email',
    serializer: yup
      .string()
      .email(DtoMessageEnum.INCORRECT_EMAIL),
  },
  phone: {
    sortable: true,
    optional: true,
    label: 'Телефон',
    serializer: yup
      .string()
      .matches(/^7\d{10}$/i, DtoMessageEnum.INCORRECT_PHONE),
  },
  gmail: {
    optional: true,
    label: 'Аккаунт в Google',
    serializer: yup.string(),
  },
  firstName: {
    label: 'Имя',
    serializer: nonEmptyStringSchema,
  },
  middleName: {
    optional: true,
    label: 'Отчество',
    serializer: yup.string(),
  },
  lastName: {
    optional: true,
    label: 'Фамилия',
    serializer: yup.string(),
  },
  file: {
    optional: true,
    label: 'Аватар',
    serializer: entityLikeSchemaUuid,
    checkers: [StorageBackendValidatorsEnum.FILE_ASSERT_EXISTS_BY_DTO],
  },
  cardOnNewTab: {
    optional: true,
    label: 'Открывать карточку в новой странице',
    serializer: yup.boolean(),
  },
});
